/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { accountsConnect } from "../../funcs/accountsConnect.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ConnectAccountRequest$inboundSchema,
};

export const tool$accountsConnect: ToolDefinition<typeof args> = {
  name: "accounts-connect",
  description:
    `Shares access scopes from the account specified to the caller, establishing a connection 
between the two accounts with the specified permissions.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await accountsConnect(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(void 0, apiCall);
  },
};
